"use strict";
// JSON Schema Specification B. Hutton Draft 01
// https://datatracker.ietf.org/doc/html/draft-bhutton-json-schema-01
exports.__esModule = true;
